module.exports = __webpack_public_path__ + "static/Customize-Welcome-Message-4a-e1403554687297-9580ab95e7122db0dd8cb1e6b18f9c69.jpg";